import Modal from "../classes/ModalClass";

const selectors = {
    el: '.js-modal:not(.is-initialized)'
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        el.modal = new Modal(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;